<template>
  <v-container class="content-box">
    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="user-application-info pb-16">
        <div class="mt-10 main-title pc-size d-flex">
          <div>
            <slot>申請詳細</slot>
          </div>
          <div class="ml-6">
            <span
              class="ma-3 status"
              :class="'tag' + certificateForm.status_code"
            >
              {{ status_text }}
            </span>
          </div>
        </div>
        <v-divider class="mt-5 header-line-driver"></v-divider>
        <v-container class="mt-7 ml-2 pa-4 pb-10">
          <v-row>
            <v-col cols="12" sm="4">
              <v-card height="70px" outlined class="v-card-bg-color pa-1">
                <field-label-normal class="ml-4 mt-2 custom-label"
                  >認定証の種類</field-label-normal
                ><br />
                <field-label-normal class="ml-4 label-top custom-label-data">{{
                  certificateForm.cert_code_name
                }}</field-label-normal>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card height="70px" outlined class="v-card-bg-color pa-1">
                <field-label-normal class="ml-4 mt-2 custom-label"
                  >資格番号</field-label-normal
                ><br />
                <field-label-normal class="ml-4 label-top custom-label-data">{{
                  certificateForm.cert_number_rev
                }}</field-label-normal>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card height="70px" outlined class="v-card-bg-color pa-1">
                <field-label-normal class="ml-4 mt-2 custom-label"
                  >資格取得日</field-label-normal
                ><br />
                <field-label-normal class="ml-4 label-top custom-label-data">{{
                  certificateForm.cert_regist_date
                }}</field-label-normal>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-card height="70px" outlined class="v-card-bg-color pa-1">
                <field-label-normal class="ml-4 mt-2 custom-label"
                  >有効期限</field-label-normal
                ><br />
                <field-label-normal class="ml-4 label-top custom-label-data">{{
                  certificateForm.cert_expiry_date
                }}</field-label-normal>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card height="70px" outlined class="v-card-bg-color pa-1">
                <field-label-normal class="ml-4 mt-2 custom-label"
                  >更新完了日</field-label-normal
                ><br />
                <field-label-normal class="ml-4 label-top custom-label-data">{{
                  certificateForm.cert_update_date
                    ? certificateForm.cert_update_date
                    : "-"
                }}</field-label-normal>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="mt-3 line-driver border-0"></v-divider>
        <v-container class="pa-4 pb-10">
          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="!patternA"
                >支部名</field-label-normal
              >
              <v-select
                :items="branches"
                item-text="name"
                item-value="code"
                v-model="certificateForm.branch_code"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.branch_code
                    ? showError.branch_code
                    : !patternA
                    ? requiredSelectRules
                    : []
                "
                ref="branchNm"
                placeholder="選択してください"
                :disabled="patternA"
                @change="changeBranch"
                @input="showError.branch_code = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="!patternA"
                >所属会社名</field-label-normal
              >
              <v-select
                :items="companies"
                item-text="company_name"
                item-value="id"
                v-model="certificateForm.company_name"
                :rules="
                  showError.company_name
                    ? showError.company_name
                    : !patternA
                    ? requiredSelectRules
                    : []
                "
                dense
                outlined
                hide-details="auto"
                placeholder="選択してください"
                @input="showError.company_name = ''"
                :disabled="patternA"
              >
              </v-select>
            </v-col>
          </v-row>
          <div class="mt-6">
            <field-label-normal :requiredMark="!patternA">氏名</field-label-normal>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="certificateForm.cert_name"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_name
                      ? showError.cert_name
                      : !patternA
                      ? certNameRules
                      : []
                  "
                  :readonly="patternA"
                  @input="showError.cert_name = ''"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-6">
            <field-label-normal :requiredMark="!patternA"
              >氏名カナ</field-label-normal
            >
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="certificateForm.cert_kana_name"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_kana_name
                      ? showError.cert_kana_name
                      : !patternA
                      ? certNameKanaRules
                      : []
                  "
                  :readonly="patternA"
                  @input="showError.cert_kana_name = ''"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-6 error-message">
            <field-label-normal :requiredMark="patternB"
              >自宅 住所</field-label-normal
            >
            <v-form ref="zipcodeForm" v-model="zipcodeValid" lazy-validation>
              <div class="text-sub-title pb-3">郵便番号</div>
              <div class="d-flex mx-n3 my-n1">
                <v-col cols="5" sm="2" class="pr-0 pt-0">
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.zipCdPart1"
                    dense
                    outlined
                    hide-details="auto"
                    :class="
                      isChangeColumn('cert_zipcode') ? 'changed-col-bg' : ''
                    "
                    :readonly="!patternB"
                    :rules="
                      showError.zipCdPart1
                        ? showError.zipCdPart1
                        : patternB
                        ? [zipcodeFullValidation].concat(requiredRules)
                        : []
                    "
                    @change="validateZipcode"
                    @input="
                      showError.zipCdPart1 = '';
                      validateZipcode;
                    "
                  >
                    <div slot="append-outer">―</div>
                  </v-text-field>
                </v-col>
                <v-col cols="4" sm="2" class="pr-0 pt-0">
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.zipCdPart2"
                    dense
                    outlined
                    hide-details="auto"
                    :class="
                      isChangeColumn('cert_zipcode') ? 'changed-col-bg' : ''
                    "
                    :readonly="!patternB"
                    :rules="
                      showError.zipCdPart2
                        ? showError.zipCdPart2
                        : patternB
                        ? [zipcodeFullValidation].concat(requiredRules)
                        : []
                    "
                    @change="validateZipcode"
                    @input="
                      showError.zipCdPart2 = '';
                      validateZipcode;
                    "
                  ></v-text-field>
                </v-col>
              </div>
            </v-form>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="4" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">都道府県</div>
                <v-select
                  :items="prefectures"
                  v-model="certpref"
                  :class="
                    isChangeColumn('cert_prefectures') ? 'changed-col-bg' : ''
                  "
                  dense
                  outlined
                  hide-details="auto"
                  :disabled="!patternB"
                  :rules="
                    showError.cert_prefectures
                      ? showError.cert_prefectures
                      : patternB
                      ? prefecturesRules
                      : []
                  "
                  @input="showError.cert_prefectures = ''"
                  placeholder="選択してください"
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">住所</div>
                <v-text-field
                  v-model="certadd"
                  dense
                  outlined
                  hide-details="auto"
                  :class="
                    isChangeColumn('cert_address1') ? 'changed-col-bg' : ''
                  "
                  :readonly="!patternB"
                  :rules="
                    showError.cert_address1
                      ? showError.cert_address1
                      : patternB
                      ? address1Rules
                      : []
                  "
                  @input="showError.cert_address1 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">マンション名</div>
                <v-text-field
                  v-model="certificateForm.cert_address2"
                  dense
                  outlined
                  hide-details="auto"
                  :class="
                    isChangeColumn('cert_address2') ? 'changed-col-bg' : ''
                  "
                  :readonly="!patternB"
                  :rules="
                    showError.cert_address2
                      ? showError.cert_address2
                      : patternB
                      ? address2Rules
                      : []
                  "
                  @input="showError.cert_address2 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row class="mt-2">
            <v-col cols="12" sm="5">
              <field-label-normal>電話番号</field-label-normal>
              <v-text-field
                type="tel"
                v-model="certificateForm.tel"
                dense
                outlined
                hide-details="auto"
                :class="isChangeColumn('tel') ? 'changed-col-bg' : ''"
                :readonly="!patternB"
                :rules="
                  showError.tel ? showError.tel : patternB ? telRules : []
                "
                @input="showError.tel = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="patternB"
                >メールアドレス</field-label-normal
              >
              <v-text-field
                v-model="certificateForm.email"
                dense
                outlined
                hide-details="auto"
                :readonly="!patternB"
                :class="isChangeColumn('email') ? 'changed-col-bg' : ''"
                :rules="
                  showError.email ? showError.email : patternB ? emailRules : []
                "
                @input="showError.email = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="3">
              <field-label-normal :requiredMark="!patternA"
                >生年月日</field-label-normal
              >
              <v-menu
                v-model="birthDateShow"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="certificateForm.birthday"
                    :class="patternA ? 'datepickreadonly' : 'datepick'"
                    append-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:append="birthDateShow = true"
                    :rules="
                      showError.birthday
                        ? showError.birthday
                        : !patternA
                        ? requiredRules
                        : []
                    "
                    @input="showError.birthday = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="certificateForm.birthday"
                  @input="birthDateShow = false"
                  :disabled="patternA"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-n8">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="patternB"
                >申請理由</field-label-normal
              >
              <v-select
                :items="requests"
                item-text="name"
                item-value="code"
                v-model="certificateForm.request_code"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.request_code
                    ? showError.request_code
                    : patternB
                    ? requiredSelectRules
                    : []
                "
                :disabled="!patternB"
                :class="isChangeColumn('request_code') ? 'changed-col-bg' : ''"
                @change="changedAppliText($event)"
                @input="showError.request_code = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <!-- after_image_uploaded -->
          <div
            v-show="
              imageShowPattern ||
              certificateForm.request_code == requestcode.EXPIRED ||
              (certificateForm.request_code == requestcode.OTHER &&
              ((image_preview_show_1 || certificateForm.status_code != statuscode.APPLYING)))
            "
            class="mt-6"
            @drop="dropThumb($event)"
            @dragenter="startDrop($event)"
            @dragleave="endDrop($event)"
            @dragover.prevent
          >
            <field-label-normal :requiredMark="patternB && certificateForm.request_code != requestcode.OTHER"
              >顔写真アップロード</field-label-normal
            >
            <field-label-normal class="pb-2"
              >※ 3ヶ月以内の顔写真（ jpeg形式、3MB以内
              ）を添付してください。</field-label-normal
            >
            <v-row class="image_up">
              <div v-show="image_preview_show_1" class="mt-3 ml-3">
                <div
                  class="imagePreviewWrapper"
                  :style="{ 'background-image': `url(${previewImage_1})` }"
                  @click="selectImage"
                ></div>
              </div>
              <div class="col-sm-6" v-show="patternB">
                <v-card
                  class="vcard-upload"
                  :class="dragging ? 'dropZone-over' : ''"
                  @dragover="_ondragover($event)"
                  @drop="_ondrop($event)"
                  @dragleave="_ondragleave($event)"
                  @dragenter="_ondragenter($event)"
                  v-show="image_display_only_1"
                  height="132px"
                  outlined
                >
                  <div
                    class="after-pickup-title1 px-1"
                    :class="after_image_upload ? 'pickup1-mobile' : ''"
                  >
                    ファイルをドラッグ＆ドロップしてください
                  </div>
                  <div
                    class="after-pickup-title2"
                    :class="after_image_upload ? 'pickup2-mobile' : ''"
                  >
                    または
                    <v-btn
                      depressed
                      class="btn-pickup-margin"
                      :class="after_image_upload ? 'pickup-button' : ''"
                      height="35"
                      :disabled="!patternB"
                      @click="selectImageClick"
                      >ファイルを選択</v-btn
                    >
                  </div>
                  <input
                    ref="uploader_img"
                    :src="certificateForm.appli_image"
                    class="d-none"
                    type="file"
                    accept="image/jpeg"
                    @change="imgOnFileChanged"
                    @input="showError.appli_image = ''"
                  />
                </v-card>
              </div>
            </v-row>
            <v-card-text v-if="showError.appli_image" class="error--text">
              {{ showError.appli_image[0] }}
            </v-card-text>
          </div>
          <!-- end after_image_uploaded -->
          <div class="col-sm-8 mt-0" v-show="after_image_upload">
            <v-container>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7">
                  <div class="uploaded-data-title col-sm-12">ファイル名</div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex">
                  <div class="col-sm-8 sizepos" style="align-items: end">
                    サイズ
                  </div>
                  <div class="col-sm-4 pc-size"></div>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-divider class="info-line-driver border-0"></v-divider>
              </v-row>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7">
                  <div class="uploaded-data-title truncate pl-3">
                    {{ upload_image_file_name }}
                  </div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex py-2 justify-left">
                  <div class="py-2 col-sm-8 sizepos">
                    {{ upload_image_file_size }}
                  </div>
                  <v-btn
                    :disabled="!patternB"
                    @click="deleteUploadImage"
                    class="col-sm-4 delete-icon py-2"
                    text
                    icon
                    color="black"
                    v-show="patternB"
                  >
                    <svg-icon
                      iconClass="Icon feather-trash-2"
                      class="trash-icon"
                    />
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- after_image_or_pdf_uploaded -->
          <div
            v-show="certificateForm.request_code == requestcode.MOVECOMPANY"
            class="mt-6"
            @drop="dropThumbPdf($event)"
            @dragenter="startDrop($event)"
            @dragleave="endDrop($event)"
            @dragover.prevent
          >
            <field-label-normal :requiredMark="true"
              >PDF書類アップロード</field-label-normal
            >
            <field-label-normal class="pb-2"
              >※ 旧取得会社の代表者印のある書類（ PDF／jpeg形式、3MB以内
              ）を添付してください。</field-label-normal
            >
            <v-row class="image_up">
              <div v-show="image_preview_show_2" class="mt-3 ml-3">
                <div
                  class="imagePreviewWrapper"
                  :style="{ 'background-image': `url(${previewImage_2})` }"
                  @click="selectImage"
                ></div>
              </div>
              <div class="col-sm-6" v-show="patternB">
                <v-card
                  class="vcard-upload"
                  :class="dragging ? 'dropZone-over' : ''"
                  @dragover="_ondragover($event)"
                  @drop="_ondrop($event)"
                  @dragleave="_ondragleave($event)"
                  @dragenter="_ondragenter($event)"
                  v-show="image_display_only_2"
                  height="132px"
                  outlined
                >
                  <div
                    class="after-pickup-title1 px-1"
                    :class="after_image_pdf_upload ? 'pickup1-mobile' : ''"
                  >
                    ファイルをドラッグ＆ドロップしてください
                  </div>
                  <div
                    class="after-pickup-title2"
                    :class="after_image_pdf_upload ? 'pickup2-mobile' : ''"
                  >
                    または
                    <v-btn
                      depressed
                      class="btn-pickup-margin"
                      :class="after_image_pdf_upload ? 'pickup-button' : ''"
                      height="35"
                      @click="selectImagePdfClick"
                      >ファイルを選択</v-btn
                    >
                  </div>
                  <input
                    ref="uploader_img_pdf"
                    :src="certificateForm.appli_upload_file"
                    class="d-none"
                    type="file"
                    accept=".pdf,image/jpeg"
                    :rules="
                      showError.appli_upload_file
                        ? showError.appli_upload_file
                        : patternB
                        ? requiredRules
                        : []
                    "
                    @change="imagepdfOnFileChanged"
                    @input="showError.appli_upload_file = ''"
                  />
                </v-card>
              </div>
            </v-row>
            <v-card-text v-if="showError.appli_upload_file" class="error--text">
              {{ showError.appli_upload_file[0] }}
            </v-card-text>
          </div>
          <!-- end after_image_or_pdf_uploaded -->
          <div class="col-sm-8 mt-2" v-show="uploaded_image_pdf_info">
            <v-container>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7" class="py-0">
                  <div class="uploaded-data-title col-sm-12">ファイル名</div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex py-0">
                  <div class="col-sm-8 sizepos" style="align-items: end">
                    サイズ
                  </div>
                  <div class="col-sm-4 pc-size"></div>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-divider class="info-line-driver border-0"></v-divider>
              </v-row>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7">
                  <div class="uploaded-data-title truncate pl-3">
                    {{ upload_image_pdf_file_name }}
                  </div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex py-2 justify-left">
                  <div class="py-2 col-sm-8 sizepos">
                    {{ upload_image_pdf_file_size }}
                  </div>
                  <v-btn
                    @click="deleteUploadPdfImage"
                    v-show="patternB"
                    class="col-sm-4 delete-icon py-2"
                    text
                    icon
                    color="black"
                  >
                    <svg-icon
                      iconClass="Icon feather-trash-2"
                      class="trash-icon"
                    />
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div
            class="mt-4 ml-1 pastdata"
            v-show="
              uploaded_image_pdf_files.length > 0 ||
              uploaded_image_files.length > 0
            "
          >
            <v-dialog v-model="dialog" width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title v-bind="attrs" v-on="on">
                  <field-label-normal
                    class="text-decoration-underline link-color"
                    >過去にアップロードした書類を確認する</field-label-normal
                  >
                </v-list-item-title>
              </template>
              <v-card class="ml-0 popup-vcard">
                <v-list-item class="d-block">
                  <v-list-item-content class="dialog-content">
                    <div class="mt-5 px-2 pt-5 pb-2 scrollstyle">
                      <div
                        cols="12"
                        class="px-3 justify-center"
                        v-show="uploaded_image_files.length > 0"
                      >
                        <div>
                          <field-label-normal class="data-link"
                            >過去の更新時画像ファイル</field-label-normal
                          >
                        </div>
                        <v-list-item-subtitle
                          class="mt-1 d-flex"
                          v-for="uploaded_image_file in uploaded_image_files"
                          :key="uploaded_image_file.key"
                        >
                          <v-col sm="4" class="d-flex dia-icon">
                            <svg-icon iconClass="Icon awesome-file-image" />
                            <span class="pl-2 mt-2 data-link">{{
                              uploaded_image_file.date
                            }}</span>
                          </v-col>
                          <v-col sm="8" class="px-2 mt-2">
                            <span
                              class="text-decoration-underline file-name"
                              @click="downloadImage(uploaded_image_file)"
                              >{{ uploaded_image_file.imagename }}</span
                            ></v-col
                          >
                        </v-list-item-subtitle>
                      </div>
                      <div
                        cols="12"
                        class="px-3 justify-center"
                        v-show="uploaded_image_pdf_files.length > 0"
                      >
                        <div class="mt-7">
                          <field-label-normal class="data-link"
                            >過去の添付書類</field-label-normal
                          >
                        </div>
                        <v-list-item-subtitle
                          class="mt-1 d-flex"
                          v-for="uploaded_image_pdf_file in uploaded_image_pdf_files"
                          :key="uploaded_image_pdf_file.key"
                        >
                          <v-col sm="4" class="d-flex dia-icon">
                            <svg-icon
                              :iconClass="
                                uploaded_image_pdf_file.type ===
                                'application/pdf'
                                  ? 'Icon awesome-file-pdf'
                                  : 'Icon awesome-file-image'
                              "
                            />
                            <span class="pl-2 mt-2 data-link">{{
                              uploaded_image_pdf_file.date
                            }}</span>
                          </v-col>
                          <v-col sm="8" class="px-2 mt-2">
                            <span
                              class="text-decoration-underline file-name"
                              @click="
                                downloadpdfandImage(uploaded_image_pdf_file)
                              "
                              >{{ uploaded_image_pdf_file.filename }}</span
                            ></v-col
                          >
                        </v-list-item-subtitle>
                      </div>
                    </div>
                  </v-list-item-content>
                  <div class="diabtn">
                    <v-btn
                      class="button-size"
                      large
                      height="40"
                      width="200"
                      @click="dialog = false"
                    >
                      閉じる
                    </v-btn>
                  </div>
                </v-list-item>
              </v-card>
            </v-dialog>
          </div>
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="patternB"
                >認定証送付先</field-label-normal
              >
              <v-select
                :items="certificate_destination"
                item-text="name"
                item-value="code"
                v-model="certificateForm.deli_code"
                :class="isChangeColumn('deli_code') ? 'changed-col-bg' : ''"
                dense
                outlined
                hide-details="auto"
                ref="certificate_destination"
                placeholder="選択してください"
                :rules="
                  showError.deli_code
                    ? showError.deli_code
                    : patternB
                    ? requiredSelectRules
                    : []
                "
                :disabled="!patternB"
                @input="showError.deli_code = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <div v-show="certificateForm.deli_code == delicode.OTHER">
            <div class="mt-6 error-message">
              <field-label-normal :requiredMark="patternB"
                >送付先住所</field-label-normal
              >
              <v-form
                ref="delizipcodeForm"
                v-model="deliZipcodeValid"
                lazy-validation
              >
                <div class="text-sub-title pb-3">郵便番号</div>
                <div class="d-flex mx-n3 my-n1">
                  <v-col cols="5" sm="2" class="pr-0 pt-0">
                    <v-text-field
                      type="tel"
                      v-model="certificateForm.deli_zipCdPart1"
                      dense
                      outlined
                      :class="
                        isChangeColumn('deli_zipcode') ? 'changed-col-bg' : ''
                      "
                      hide-details="auto"
                      :rules="
                        showError.deli_zipCdPart1
                          ? showError.deli_zipCdPart1
                          : patternB &&
                            certificateForm.deli_code == delicode.OTHER
                          ? [deliZipcodeFullValidation].concat(requiredRules)
                          : []
                      "
                      :readonly="!patternB"
                      @change="deliValidateZipcode"
                      @input="
                        showError.deli_zipCdPart1 = '';
                        deliValidateZipcode;
                      "
                    >
                      <div slot="append-outer">―</div>
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" sm="2" class="pr-0 pt-0">
                    <v-text-field
                      type="tel"
                      v-model="certificateForm.deli_zipCdPart2"
                      dense
                      outlined
                      :class="
                        isChangeColumn('deli_zipcode') ? 'changed-col-bg' : ''
                      "
                      hide-details="auto"
                      :rules="
                        showError.deli_zipCdPart2
                          ? showError.deli_zipCdPart2
                          : patternB &&
                            certificateForm.deli_code == delicode.OTHER
                          ? [deliZipcodeFullValidation].concat(requiredRules)
                          : []
                      "
                      :readonly="!patternB"
                      @change="deliValidateZipcode"
                      @input="
                        showError.deli_zipCdPart2 = '';
                        deliValidateZipcode;
                      "
                    >
                    </v-text-field>
                  </v-col>
                </div>
              </v-form>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="4" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">都道府県</div>
                  <v-select
                    :items="prefectures"
                    v-model="delipref"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="
                      showError.deli_prefectures
                        ? showError.deli_prefectures
                        : patternB &&
                          certificateForm.deli_code == delicode.OTHER
                        ? prefecturesRules
                        : []
                    "
                    :disabled="!patternB"
                    :class="
                      isChangeColumn('deli_prefectures') ? 'changed-col-bg' : ''
                    "
                    @input="showError.deli_prefectures = ''"
                    placeholder="選択してください"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="8" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">住所</div>
                  <v-text-field
                    v-model="deliadd"
                    dense
                    outlined
                    hide-details="auto"
                    :class="
                      isChangeColumn('deli_address1') ? 'changed-col-bg' : ''
                    "
                    :readonly="!patternB"
                    :rules="
                      showError.deli_address1
                        ? showError.deli_address1
                        : patternB &&
                          certificateForm.deli_code == delicode.OTHER
                        ? address1Rules
                        : []
                    "
                    @input="showError.deli_address1 = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="8" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">マンション名</div>
                  <v-text-field
                    v-model="certificateForm.deli_address2"
                    dense
                    outlined
                    hide-details="auto"
                    :class="
                      isChangeColumn('deli_address2') ? 'changed-col-bg' : ''
                    "
                    :readonly="!patternB"
                    :rules="
                      showError.deli_address2
                        ? showError.deli_address2
                        : patternB &&
                          certificateForm.deli_code == delicode.OTHER
                        ? address2Rules
                        : []
                    "
                    @input="showError.deli_address2 = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="5" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">電話番号</div>
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.deli_tel"
                    dense
                    outlined
                    hide-details="auto"
                    :class="isChangeColumn('deli_tel') ? 'changed-col-bg' : ''"
                    :readonly="!patternB"
                    :rules="
                      showError.deli_tel
                        ? showError.deli_tel
                        : patternB &&
                          certificateForm.deli_code == delicode.OTHER
                        ? telRules2
                        : []
                    "
                    @input="showError.deli_tel = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" sm="8">
              <field-label-normal
                :class="
                  isChangeColumn('national_cert1') ? 'changed-lab-bg' : ''
                "
                >技能士（防水施工&nbsp;&nbsp;&nbsp;アクリルゴム系塗膜防水工事作業）</field-label-normal
              >
              <v-radio-group v-model="certificateForm.national_cert1" row>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="1"
                  label="１級"
                  :value="1"
                  :disabled="!patternB"
                ></v-radio>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="2"
                  label="２級"
                  :value="2"
                  :disabled="!patternB"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" sm="8">
              <field-label-normal
                :class="
                  isChangeColumn('national_cert2') ? 'changed-lab-bg' : ''
                "
                >建築施工管理技士</field-label-normal
              >
              <v-radio-group v-model="certificateForm.national_cert2" row>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="1"
                  label="１級"
                  :value="1"
                  :disabled="!patternB"
                ></v-radio>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="2"
                  label="２級"
                  :value="2"
                  :disabled="!patternB"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="8">
              <field-label-normal>備考</field-label-normal>
              <v-textarea
                v-model="certificateForm.description"
                outlined
                :readonly="patternC"
                :rules="
                  showError.description
                    ? showError.description
                    : !patternC
                    ? descriptionRules
                    : []
                "
                class="no-radius"
                :class="isChangeColumn('description') ? 'changed-col-bg' : ''"
                @input="showError.description = ''"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-row class="btn-area ml-0">
              <v-btn
                color="#F4C500"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="cancel"
              >
                キャンセル
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.application_code ==
                    applicationcode.NOPROCESSAPP &&
                  certificateForm.status_code == statuscode.ISSUED &&
                  login_user.user_code == usertab.UNION_MEMBER
                "
                color="#EB6B35"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="apply"
              >
                申請
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.status_code == statuscode.APPROVED &&
                  login_user.user_code == usertab.ADMIN &&
                  (certificateForm.application_code == applicationcode.NEWAPP ||
                    certificateForm.application_code ==
                      applicationcode.RENEWALAPP ||
                    certificateForm.application_code ==
                      applicationcode.REISSUEAPP)
                "
                color="#EB6B35"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="issued"
              >
                発行完了
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.application_code ==
                    applicationcode.NOPROCESSAPP &&
                  certificateForm.status_code == statuscode.ISSUED &&
                  login_user.user_code == usertab.ADMIN
                "
                color="#EB6B35"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                :disabled="
                  certificateForm.request_code != this.requestcode.NODATA
                "
                @click="update"
              >
                更新
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.application_code != applicationcode.NEWAPP &&
                  ((certificateForm.status_code == statuscode.APPLYING &&
                    login_user.user_code == usertab.UNION_MEMBER) ||
                    certificateForm.status_code == statuscode.REMAND)
                "
                color="#EB6B35"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="cancelApply"
              >
                申請取消
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.status_code == statuscode.APPLYING &&
                  certificateForm.application_code != applicationcode.NEWAPP &&
                  login_user.user_code != usertab.UNION_MEMBER
                "
                color="#EB6B35"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="remand"
              >
                差し戻し
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.status_code == statuscode.APPLYING &&
                  certificateForm.application_code != applicationcode.NEWAPP &&
                  login_user.user_code != usertab.UNION_MEMBER
                "
                color="#56b405"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="approve"
                >申請承認
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.application_code ==
                    applicationcode.NOPROCESSAPP &&
                  certificateForm.status_code == statuscode.ISSUED &&
                  login_user.user_code != usertab.UNION_MEMBER
                "
                color="#56b405"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                :disabled="
                  certificateForm.request_code == this.requestcode.NODATA
                "
                @click="applyAndApprove"
                >申請 + 承認
              </v-btn>
              <v-btn
                v-if="
                  certificateForm.application_code != applicationcode.NEWAPP &&
                  certificateForm.status_code == statuscode.REMAND &&
                  login_user.user_code == usertab.UNION_MEMBER
                "
                color="#56b405"
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click="reApply"
                >再申請
              </v-btn>
            </v-row>
          </div>
        </v-container>
      </div>
    </v-form>
    <confirm-dialog
      icon="mdi-alert-outline"
      iconColor="#5FBC6F"
      text="申請を取り消してよろしいですか？"
      :show="cancelDialogShow"
      @yes="cancelConfirmed"
      @cancel="cancelDialogShow = false"
    ></confirm-dialog>
  </v-container>
</template>

<script>
import FieldLabelNormal from "@/components/FormElements/FieldLabelNormal";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import {
  CERTDEST,
  STATUSCODE,
  DELICODE,
  APPLICATIONCODE,
  APPLICATIONTEXT,
  STATUSTEXT,
  REQUESTCODE,
} from "@/utils/mst-cert-dest";
import { USERTAB } from "@/utils/mst-user";
import { getBranch, getCompany, getRequest } from "@/api/common";
import validations from "@/utils/common-validation";
import {
  details,
  issued,
  remand,
  approve,
  apply,
  update,
  cancelApply,
  applyAndApprove,
  reApply,
} from "@/api/certificate";
import { Core as YubinBangoCore } from "yubinbango-core";
import { PREFS } from "@/utils/mst-prefectures";
import moment from "moment";
import { downloadImageandpdf } from "@/api/certificate";

export default {
  name: "UserEdit",
  components: {
    FieldLabelNormal,
    ConfirmDialog,
  },
  computed: {
    zipcodeFullValidation() {
      return validations.zipcodePart1AndPart2(
        this.certificateForm.zipCdPart1,
        this.certificateForm.zipCdPart2
      );
    },
    deliZipcodeFullValidation() {
      return validations.zipcodePart1AndPart2(
        this.certificateForm.deli_zipCdPart1,
        this.certificateForm.deli_zipCdPart2
      );
    },
  },
  data: () => ({
    dragging: false,
    // Form Data
    uploaded_image_files: [],
    uploaded_image_pdf_files: [],
    certificate_destination: CERTDEST,
    // 都道府県
    prefectures: PREFS,
    certificateForm: [
      {
        appli_image: "",
        appli_upload_file: "",
      },
    ],
    branches: [],
    companies: [],
    requests: [],
    delicode: DELICODE,
    statuscode: STATUSCODE,
    statustext: STATUSTEXT,
    applicationcode: APPLICATIONCODE,
    applicationtext: APPLICATIONTEXT,
    requestcode: REQUESTCODE,
    usertab: USERTAB,
    valid: true,
    zipcodeValid: true,
    deliZipcodeValid: true,
    menu: false,
    birthDateShow: false,
    uploaded_image_info: false,
    activePicker: null,
    date: null,
    pdf_image_upload: false,
    uploaded_image_pdf_info: false,
    image_preview_show_1: false,
    image_preview_show_2: false,
    after_image_upload: false,
    after_image_pdf_upload: false,
    image_display_only_1: true,
    image_display_only_2: true,
    dialog: false,
    upload_image_file_name: null,
    upload_image_file_size: null,
    upload_image_pdf_file_name: null,
    upload_image_pdf_file_size: null,
    previewImage_1: null,
    previewImage_2: null,
    prevZipcode: null,
    prevDeliZipcode: null,
    certpref: null,
    certadd: null,
    delipref: null,
    deliadd: null,
    login_user: "",
    patternA: false,
    patternB: false,
    patternC: false,
    imageShowPattern: false,
    uploaded_file: false,
    cancelDialogShow: false,
    ispdf: false,
    update_licence_message: false,
    showError: [],
    status_text: "",
    responseimage: "",
    responseimagename: "",
    uploaded_file_date: "",
    uploaded_file_name: "",
    appli_change_column: [],
    // Validations
    prefecturesRules: [],
    requiredSelectRules: [(v) => validations.requiredSelect(v)],
    requiredRules: [(v) => validations.required(v)],
    certNumberRules: [
      (v) => validations.required(v),
      (v) => validations.halfWidthNumber(v),
    ],
    // 所属会社名
    certNameRules: [
      (v) => validations.required(v),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
      (v) => validations.maxLength(v, 50),
    ],
    certNameKanaRules: [
      (v) => validations.required(v),
      (v) => validations.fullWithKata(v),
      (v) => validations.maxLength(v, 50),
    ],
    // 住所(住所/マンション名)
    address1Rules: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    address2Rules: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    // 電話番号
    telRules: [(v) => validations.tel(v)],
    telRules2: [(v) => validations.required(v), (v) => validations.tel(v)],
    // メールアドレス
    emailRules: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 200),
      (v) => validations.email(v),
    ],
    // 備考
    descriptionRules: [(v) => validations.maxLength(v, 1000)],
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  created: async function () {
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.login_user = JSON.parse(localStorage.getItem("userInfo"));
      if (this.login_user) {
        let params = {
          id: this.$route.params.id,
          user_id: this.login_user.id,
          user_code: this.login_user.user_code,
          branch_code: this.login_user.branch_code,
        };

        let params1 = {
          id: this.login_user.id,
          user_code: this.login_user.user_code,
          branch_code: this.login_user.branch_code,
        };

        await details(params).then((response) => {
          this.setDetail(response);
        });

        await getBranch(params1).then((response) => {
          this.branches = response.data;
        });

        let param = {
          user_code: this.login_user.user_code,
        };
        await getRequest(param).then((response) => {
          let norequestcode = [
            { code: this.requestcode.NODATA, name: "選択してください" },
          ];
          this.requests = norequestcode.concat(response.data);
        });

        await getCompany(params1).then((response) => {
          this.companies = response.data;
        });
      }
    },
    _ondrop(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragenter(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragleave(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragover(e) {
      e.preventDefault();
      this.dragging = true;
    },
    startDrop(e) {
      e.preventDefault();
      this.inDrop = true;
    },
    endDrop(e) {
      e.preventDefault();
      this.inDrop = false;
      this.dragging = false;
    },
    dropThumb(e) {
      e.preventDefault();
      this.imgOnFileChanged(e);
      this.dragging = false;
    },
    dropThumbPdf(e) {
      e.preventDefault();
      this.imagepdfOnFileChanged(e);
      this.dragging = false;
    },
    onEmailChange() {
      // メール存在エラーを消す
      this.emailExist = true;
    },
    onEmailInput() {
      // メール存在エラーを消す
      this.emailExist = true;
    },
    // punkTextClick() {
    //   this.$router.push("/user/certificate"); // 管理者のログイン画面に遷移
    // },
    cancel() {
      this.$router.push("/user/certificate"); // 管理者のログイン画面に遷移
    },
    setDetail(response) {
      this.uploaded_image_pdf_files = response.filetoshow;
      this.uploaded_image_files = response.imgtoshow;
      if (response.data.request_code == this.requestcode.EXPIRED || (response.data.request_code == this.requestcode.OTHER && response.certimage != "") || (response.data.application_code == this.applicationcode.NEWAPP && response.data.status_code == this.statuscode.APPROVED)) {
        this.after_image_upload = true;
        this.image_preview_show_1 = true;
        this.previewImage_1 = response.certimage;
        this.upload_image_file_name = response.certimagename;
        this.upload_image_file_size = response.certimagesize;
        this.imageShowPattern = true;
      } else if (response.data.request_code == this.requestcode.MOVECOMPANY) {
        this.uploaded_file = true;
        this.previewImage_2 = response.certimgpdf;
        this.uploaded_file_name = response.file.filename;
        this.ispdf = response.file.type == "application/pdf" ? true : false;
        this.image_preview_show_2 =
          response.file.type == "application/pdf" ? false : true;
        this.uploaded_file_date = response.file.date
          ? moment(response.file.date).format("YYYY/MM/DD H:m")
          : "";
      } else {
        this.after_image_upload = false;
        this.image_preview_show_1 = false;
        this.after_image_pdf_upload = false;
        this.image_preview_show_2 = false;
      }

      response = response.data;
      this.certificateForm = response;
      this.certificateForm.company_name = response.user_id;
      this.certificateForm.branch_code = response.get_user.branch_code;
      this.certificateForm.cert_code_name = response.get_cert_name.name;
      this.certificateForm.cert_regist_date = moment(
        response.cert_regist_date
      ).format("YYYY/MM/DD");
      this.certificateForm.cert_expiry_date = moment(
        response.cert_expiry_date
      ).format("YYYY/MM/DD");
      this.certificateForm.cert_update_date = response.cert_update_date
        ? moment(response.cert_update_date).format("YYYY/MM/DD")
        : "";

      this.certificateForm.zipCdPart1 = response.cert_zipcode.substr(0, 3);
      this.certificateForm.zipCdPart2 = response.cert_zipcode.substr(3);
      this.certpref = response.cert_prefectures;
      this.certadd = response.cert_address1;

      this.certificateForm.deli_zipCdPart1 = response.deli_zipcode
        ? response.deli_zipcode.substr(0, 3)
        : "";
      this.certificateForm.deli_zipCdPart2 = response.deli_zipcode
        ? response.deli_zipcode.substr(3)
        : "";
      this.delipref = response.deli_prefectures;
      this.deliadd = response.deli_address1;
      this.deliadd = response.deli_address1;
      let app_txt = "";
      let stu_txt = "";
      if (
        this.certificateForm.application_code == this.applicationcode.NEWAPP
      ) {
        app_txt = this.applicationtext.NEWAPP;
      } else if (
        this.certificateForm.application_code == this.applicationcode.RENEWALAPP
      ) {
        app_txt = this.applicationtext.RENEWALAPP;
      } else if (
        this.certificateForm.application_code == this.applicationcode.CHANGEAPP
      ) {
        app_txt = this.applicationtext.CHANGEAPP;
      } else if (
        this.certificateForm.application_code == this.applicationcode.REISSUEAPP
      ) {
        app_txt = this.applicationtext.REISSUEAPP;
      } else if (
        this.certificateForm.application_code == this.applicationcode.CANCELAPP
      ) {
        app_txt = this.applicationtext.CANCELAPP;
      } else {
        app_txt = this.applicationtext.NOPROCESSAPP;
      }
      if (this.certificateForm.status_code == this.statuscode.APPLYING) {
        stu_txt = this.statustext.APPLYING;
      } else if (this.certificateForm.status_code == this.statuscode.APPROVED) {
        stu_txt = this.statustext.APPROVED;
      } else if (this.certificateForm.status_code == this.statuscode.REMAND) {
        stu_txt = this.statustext.REMAND;
      } else {
        stu_txt = this.statustext.ISSUED;
      }
      this.status_text = app_txt + (app_txt != "" ? " - " : "") + stu_txt;

      if (
        !(
          this.certificateForm.application_code ==
          this.applicationcode.NOPROCESSAPP &&
          this.certificateForm.status_code == this.statuscode.ISSUED &&
          this.login_user.user_code == this.usertab.ADMIN
        )
      ) {
        this.patternA = true;
      }

      if (
        (this.certificateForm.application_code ==
          this.applicationcode.NOPROCESSAPP &&
          this.certificateForm.status_code == this.statuscode.ISSUED) ||
        (this.certificateForm.status_code == this.statuscode.REMAND &&
          this.login_user.user_code == this.usertab.UNION_MEMBER)
      ) {
        this.patternB = true;
      }

      if (
        this.certificateForm.status_code == this.statuscode.APPROVED &&
        (this.login_user.user_code != this.usertab.ADMIN ||
          this.certificateForm.application_code ==
          this.applicationcode.CANCELAPP)
      ) {
        this.patternC = true;
      }
      this.appli_change_column = JSON.parse(
        this.certificateForm.appli_change_column
      );
    },
    isChangeColumn(col) {
      let m = false;
      if (this.appli_change_column != null) {
        m = this.appli_change_column.some(function (item) {
          return item.name === col;
        });
      }
      return m;
    },
    changeBranch() {
      let params = {
        user_code: this.login_user.user_code,
        branch_code: this.certificateForm.branch_code,
        changeflg: true,
      };
      this.certificateForm.company_name = '';
      getCompany(params).then((response) => {
        this.companies = response.data;
      });
    },
    selectImageClick() {
      window.addEventListener(
        "focus",
        () => {
          // this.isSelecting_img = false;
        },
        { once: true }
      );
      this.$refs.uploader_img.click();
    },
    imgOnFileChanged(e) {
      this.dragging = false;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        if (
          files[0].type === "" ||
          !["image/jpeg", "image/jpg"].includes(files[0].type)
        ) {
          this.image_preview_show_1 = false;
          this.certificateForm.appli_image = null;
          this.showError.appli_image = true;
          this.showError.appli_image = ["顔写真はjpegタイプのみ有効です"];
          this.upload_image_file_name = files[0].name;
          this.after_image_upload = false;
          return;
        } else if (Math.ceil((files[0].size / 1024).toFixed(3)) > 3072) {
          this.certificateForm.appli_image = null;
          this.image_preview_show_1 = false;
          this.showError.appli_image = true;
          this.showError.appli_image = ["顔写真は3MB以内のファイルのみ有効です"];
          this.upload_image_file_name = files[0].name;
          this.after_image_upload = false;
        } else {
          this.showError.appli_image = false;
          this.showError.appli_image = [];
          this.upload_image_file_name = files[0].name;
          this.upload_image_file_size =
            Math.ceil((files[0].size / 1024).toFixed(3)) + "KB";
          this.image_preview_show_1 = true;
          let reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage_1 = e.target.result;
          };
          reader.readAsDataURL(files[0]);
          this.$emit("input", files[0]);
          this.certificateForm.appli_image = files[0];
          this.certificateForm.appli_image_name = files[0].name;
          this.after_image_upload = true;
        }
      } else {
        this.image_preview_show_1 = false;
        this.certificateForm.appli_image = null;
        if(this.certificateForm.request_code != this.requestcode.OTHER) {
          this.showError.appli_image = true;
          this.showError.appli_image = ["顔写真は必要項目です"];
        }else {
          this.showError.appli_image = false;
          this.showError.appli_image = [];
        }
        this.upload_image_file_name = "";
        this.after_image_upload = false;
      }
    },
    selectImagePdfClick() {
      window.addEventListener(
        "focus",
        () => {
          //this.isSelecting_img_pdf = false;
        },
        { once: true }
      );
      this.$refs.uploader_img_pdf.click();
    },
    imagepdfOnFileChanged(e) {
      this.dragging = false;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        if (
          files[0].type === "" ||
          !["image/jpeg", "image/jpg", "application/pdf"].includes(files[0].type)
        ) {
          this.image_preview_show_2 = false;
          this.certificateForm.appli_upload_file = null;
          this.showError.appli_upload_file = true;
          this.showError.appli_upload_file = [
            "書類アップロード は PDF／jpegタイプのみ有効です",
          ];
          this.upload_image_pdf_file_name = "";
          this.uploaded_image_pdf_info = false;
          return;
        } else if (Math.ceil((files[0].size / 1024).toFixed(3)) > 3072) {
          this.image_preview_show_2 = false;
          this.certificateForm.appli_upload_file = null;
          this.showError.appli_upload_file = true;
          this.showError.appli_upload_file = [
            "書類アップロード は3MB以内のファイルのみ有効です",
          ];
          this.upload_image_pdf_file_name = files[0].name;
          this.uploaded_image_pdf_info = false;
          return;
        } else {
          this.showError.appli_upload_file = false;
          this.showError.appli_upload_file = [];
          if (files[0]["type"] === "image/jpeg") {
            this.image_preview_show_2 = true;
            let reader = new FileReader();
            reader.onload = (e) => {
              this.previewImage_2 = e.target.result;
            };
            reader.readAsDataURL(files[0]);
            this.$emit("input", files[0]);
            this.after_image_pdf_upload = true;
            this.pdf_image_upload = false;
          } else {
            this.image_preview_show_2 = false;
            this.after_image_pdf_upload = false;
            this.pdf_image_upload = true;
          }
          this.certificateForm.appli_upload_file = files[0];
          this.upload_image_pdf_file_name = files[0].name;
          this.upload_image_pdf_file_size =
            Math.ceil((files[0].size / 1024).toFixed(3)) + "KB";
          this.uploaded_image_pdf_info = true;
        }
      } else {
        this.image_preview_show_2 = false;
        this.certificateForm.appli_upload_file = null;
        this.showError.appli_upload_file = true;
        this.showError.appli_upload_file = [
          "書類アップロードは必要項目です",
        ];
        this.upload_image_pdf_file_name = "";
        this.uploaded_image_pdf_info = false;
        return;
      }
    },
    deleteUploadImage() {
      this.upload_image_file_name = null;
      this.upload_image_file_size = null;
      this.previewImage_1 = null;
      this.uploaded_image_info = false;
      this.after_image_upload = false;
      this.$refs.uploader_img.value = null;
      this.image_preview_show_1 = false;
      this.certificateForm.appli_image = null;
    },
    deleteUploadPdfImage() {
      this.upload_image_pdf_file_name = null;
      this.upload_image_pdf_file_size = null;
      this.previewImage_2 = null;
      this.after_image_pdf_upload = false;
      this.uploaded_image_pdf_info = false;
      this.$refs.uploader_img_pdf.value = null;
      this.image_preview_show_2 = false;
      this.certificateForm.appli_upload_file = null;
    },
    changedAppliText() {
      this.after_image_upload = false;
      this.after_image_pdf_upload = false;
      this.uploaded_image_pdf_info = false;
      this.deleteUploadImage();
      this.deleteUploadPdfImage();
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    validateZipcode() {
      this.$refs.zipcodeForm.validate();
      if (this.zipcodeValid) {
        var newVal =
          this.certificateForm.zipCdPart1 + this.certificateForm.zipCdPart2;
        if (this.prevZipcode != newVal) {
          new YubinBangoCore(newVal, (addr) => {
            if (addr.region) {
              this.certpref = addr.region;
              this.certadd = addr.locality + addr.street;
            }
          });
        }
        this.prevZipcode = newVal;
      }
    },
    deliValidateZipcode() {
      this.$refs.delizipcodeForm.validate();
      if (this.deliZipcodeValid) {
        var newVal =
          this.certificateForm.deli_zipCdPart1 +
          this.certificateForm.deli_zipCdPart2;
        if (this.prevDeliZipcode != newVal) {
          new YubinBangoCore(newVal, (addr) => {
            if (addr.region) {
              this.delipref = addr.region;
              this.deliadd = addr.locality + addr.street;
            }
          });
        }
        this.prevDeliZipcode = newVal;
      }
    },
    async downloadImage(uploaded_image_file) {
      const data = {
        type: "image",
        id: this.certificateForm.id,
        downloadimage: uploaded_image_file.image,
      };
      await downloadImageandpdf(data).then((response) => {
        var filename = uploaded_image_file.imagename;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      });
    },
    async downloadpdfandImage(uploaded_image_pdf_file) {
      const data = {
        type: "pdfandimage",
        id: this.certificateForm.id,
        downloadimage: uploaded_image_pdf_file.path,
        uploadtype: uploaded_image_pdf_file.type,
      };
      await downloadImageandpdf(data).then((response) => {
        var filename = uploaded_image_pdf_file.filename;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      });
    },

    deleteImgRow: function (uploaded_image_file) {
      var idx = this.uploaded_image_files.indexOf(uploaded_image_file);
      if (idx > -1) {
        this.uploaded_image_files.splice(idx, 1);
      }
    },
    deleteImgPdfRow: function (uploaded_image_pdf_file) {
      var idx = this.uploaded_image_pdf_files.indexOf(uploaded_image_pdf_file);
      if (idx > -1) {
        this.uploaded_image_pdf_files.splice(idx, 1);
      }
    },
    async issued() {
      //発行完了
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.certificateForm.loginid = this.login_user.id;
      await issued(this.certificateForm).then((response) => {
        if (response.message == "invalidInput") {
          this.showError = response.error;
        } else if (response.success == true) {
          this.showError = [];
          this.$store.commit("SAVE_DIALOG", {
            text: "保存しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          this.$router.push("/user/certificate?tabId=4");
        }
      });
    },
    async remand() {
      //差し戻し
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.certificateForm.loginid = this.login_user.id;
      await remand(this.certificateForm).then((response) => {
        if (response.message == "invalidInput") {
          this.showError = response.error;
        } else if (response.success == true) {
          this.showError = [];
          this.$store.commit("SAVE_DIALOG", {
            text: "保存しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          this.$router.push("/user/certificate?tabId=3");
        }
      });
    },
    async approve() {
      //申請承認
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      var tabId = 2;//承認済み
      if (this.certificateForm.request_code == this.requestcode.CHANGE || this.certificateForm.request_code == this.requestcode.MOVECOMPANY || this.certificateForm.request_code == this.requestcode.OTHER) {
        tabId = 4;//発行済み
      }
      this.certificateForm.loginid = this.login_user.id;
      await approve(this.certificateForm).then((response) => {
        if (response.message == "invalidInput") {
          this.showError = response.error;
        } else if (response.success == true) {
          this.showError = [];
          this.$store.commit("SAVE_DIALOG", {
            text: "保存しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          this.$router.push("/user/certificate?tabId="+tabId);
        }
      });
    },
    async apply() {
      //申請
      await this.$refs.form.validate();
      await this.$refs.zipcodeForm.validate();
      await this.$refs.delizipcodeForm.validate();
      if (!this.valid) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      if (this.certificateForm.request_code == this.requestcode.NODATA) {
        this.certificateForm.request_code = "";
      }

      this.update_licence_message = false;
      if (this.certificateForm.request_code == this.requestcode.EXPIRED) {
        let expdatefromtoday = moment().add(3, "M");
        let expdate = moment(this.certificateForm.cert_expiry_date).format(
          "YYYY/MM/DD"
        );
        expdatefromtoday = moment(expdatefromtoday).format("YYYY/MM/DD");
        if (moment(expdate).isAfter(expdatefromtoday)) {
          this.update_licence_message = true;
        }
      }

      if (this.update_licence_message) {
        this.$store.commit("SAVE_DIALOG", {
          text: "更新申請は有効期限の3ヶ月前より行えます",
          icon: "mdi-alert-outline",
          iconColor: "#e8a43e",
          closebtntext: "OK",
        });
      } else {
        this.certificateForm.loginid = this.login_user.id;
        this.certificateForm.id = this.$route.params.id;
        var data = this.AppendData();
        await apply(data).then((response) => {
          if (response.message == "invalidInput") {
            this.showError = response.error;
            let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop
            );
          } else if (response.success == true) {
            this.showError = [];
            this.$store.commit("SAVE_DIALOG", {
              text: "保存しました",
              icon: "mdi-checkbox-marked-circle-outline",
            });
            this.$router.push("/user/certificate?tabId=1");
          }
        });
      }
    },
    async update() {
      //5年後更新
      await this.$refs.form.validate();
      await this.$refs.zipcodeForm.validate();
      await this.$refs.delizipcodeForm.validate();
      if (!this.valid) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      this.certificateForm.deli_prefectures = this.delipref;
      this.certificateForm.deli_address1 = this.deliadd;
      this.certificateForm.cert_prefectures = this.certpref;
      this.certificateForm.cert_address1 = this.certadd;
      this.certificateForm.loginid = this.login_user.id;
      await update(this.certificateForm).then((response) => {
        if (response.message == "invalidInput") {
          this.showError = response.error;
          let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft,
            domRect.top + document.documentElement.scrollTop
          );
        } else if (response.success == true) {
          this.showError = [];
          this.$store.commit("SAVE_DIALOG", {
            text: "保存しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          this.$router.push("/user/certificate?tabId=4");
        }
      });
    },
    cancelApply() {
      this.cancelDialogShow = true;
    },
    async cancelConfirmed() {
      this.cancelDialogShow = false;
      this.certificateForm.loginid = this.login_user.id;
      await cancelApply(this.certificateForm).then((response) => {
        if (response.success == true) {
          this.showError = [];
          this.$store.commit("SAVE_DIALOG", {
            text: "保存しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          this.$router.push("/user/certificate?tabId=4");
        }
      });
    },
    async applyAndApprove() {
      //申請＋承認
      await this.$refs.form.validate();
      await this.$refs.zipcodeForm.validate();
      await this.$refs.delizipcodeForm.validate();
      if (!this.valid) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      if (this.certificateForm.request_code == this.requestcode.NODATA) {
        this.certificateForm.request_code = "";
      }
      this.update_licence_message = false;
      if (this.certificateForm.request_code == this.requestcode.EXPIRED) {
        let expdatefromtoday = moment().add(3, "M");
        let expdate = moment(this.certificateForm.cert_expiry_date).format(
          "YYYY/MM/DD"
        );
        expdatefromtoday = moment(expdatefromtoday).format("YYYY/MM/DD");
        if (moment(expdate).isAfter(expdatefromtoday)) {
          this.update_licence_message = true;
        }
      }
      if (this.update_licence_message) {
        this.$store.commit("SAVE_DIALOG", {
          text: "更新申請は有効期限の3ヶ月前より行えます",
          icon: "mdi-alert-outline",
          iconColor: "#e8a43e",
          closebtntext: "OK",
        });
      } else {
        this.certificateForm.loginid = this.login_user.id;
        this.certificateForm.id = this.$route.params.id;
        var tabId = 2;
        if (this.certificateForm.request_code == this.requestcode.CHANGE || this.certificateForm.request_code == this.requestcode.MOVECOMPANY || this.certificateForm.request_code == this.requestcode.OTHER) {
          tabId = 4;
        }
        var data = this.AppendData();
        await applyAndApprove(data).then((response) => {
          if (response.message == "invalidInput") {
            this.showError = response.error;
            let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop
            );
          } else if (response.success == true) {
            this.showError = [];
            this.$store.commit("SAVE_DIALOG", {
              text: "保存しました",
              icon: "mdi-checkbox-marked-circle-outline",
            });
            this.$router.push("/user/certificate?tabId=" + tabId);
          }
        });
      }
    },
    async reApply() {
      //再申請
      await this.$refs.form.validate();
      await this.$refs.zipcodeForm.validate();
      await this.$refs.delizipcodeForm.validate();
      if ((!this.valid)) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      if (this.certificateForm.request_code == this.requestcode.NODATA) {
        this.certificateForm.request_code = "";
      }

      this.update_licence_message = false;
      if (this.certificateForm.request_code == this.requestcode.EXPIRED) {
        let expdatefromtoday = moment().add(3, "M");
        let expdate = moment(this.certificateForm.cert_expiry_date).format(
          "YYYY/MM/DD"
        );
        expdatefromtoday = moment(expdatefromtoday).format("YYYY/MM/DD");
        if (moment(expdate).isAfter(expdatefromtoday)) {
          this.update_licence_message = true;
        }
      }

      if (this.update_licence_message) {
        this.$store.commit("SAVE_DIALOG", {
          text: "更新申請は有効期限の3ヶ月前より行えます",
          icon: "mdi-alert-outline",
          iconColor: "#e8a43e",
          closebtntext: "OK",
        });
      } else {
        this.certificateForm.loginid = this.login_user.id;
        this.certificateForm.id = this.$route.params.id;
        var data = this.AppendData();
        await reApply(data).then((response) => {
          if (response.message == "invalidInput") {
            this.showError = response.error;
            let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop
            );
          } else if (response.success == true) {
            this.showError = [];
            this.$store.commit("SAVE_DIALOG", {
              text: "保存しました",
              icon: "mdi-checkbox-marked-circle-outline",
            });
            this.$router.push("/user/certificate?tabId=1");
          }
        });
      }
    },
    AppendData: function () {
      this.showError.appli_image = [];
      this.showError.appli_upload_file = [];
      var data = new FormData();
      data.append("id", this.certificateForm.id);
      data.append("loginid", this.certificateForm.loginid);
      data.append("status_code", this.certificateForm.status_code);
      data.append("cert_code_name", this.certificateForm.cert_code_name);
      data.append("cert_number", this.certificateForm.cert_number);
      data.append("cert_number_rev", this.certificateForm.cert_number_rev);
      data.append("cert_regist_date", this.certificateForm.cert_regist_date);
      data.append("cert_expiry_date", this.certificateForm.cert_expiry_date);
      data.append("cert_update_date", this.certificateForm.cert_update_date);
      data.append("branch_code", this.certificateForm.branch_code);
      data.append("company_name", this.certificateForm.company_name);
      data.append("cert_name", this.certificateForm.cert_name);
      data.append("cert_kana_name", this.certificateForm.cert_kana_name);
      data.append("zipCdPart1", this.certificateForm.zipCdPart1);
      data.append("zipCdPart2", this.certificateForm.zipCdPart2);
      data.append("cert_prefectures", this.certpref);
      data.append("cert_address1", this.certadd);
      data.append("cert_address2", this.certificateForm.cert_address2);
      data.append("tel", this.certificateForm.tel);
      if(this.certificateForm.cert_address2) {
        data.append("cert_address2", this.certificateForm.cert_address2);
      }
      if(this.certificateForm.tel) {
        data.append("tel", this.certificateForm.tel);
      }
      data.append("email", this.certificateForm.email);
      data.append("cert_code", this.certificateForm.cert_code);
      data.append("birthday", this.certificateForm.birthday);
      data.append("request_code", this.certificateForm.request_code);
      data.append("appli_image", this.certificateForm.appli_image);
      data.append("appli_image_size", this.upload_image_file_size);
      data.append("appli_upload_file", this.certificateForm.appli_upload_file);
      data.append("appli_upload_file_size", this.upload_image_pdf_file_size);
      if(this.certificateForm.deli_code) {
        data.append("deli_code", this.certificateForm.deli_code);
      }
      if(this.certificateForm.deli_zipCdPart1) {
        data.append("deli_zipCdPart1", this.certificateForm.deli_zipCdPart1);
      }
      if(this.certificateForm.deli_zipCdPart2) {
        data.append("deli_zipCdPart2", this.certificateForm.deli_zipCdPart2);
      }
      if(this.delipref) {
        data.append("deli_prefectures", this.delipref);
      }
      if(this.deliadd) {
        data.append("deli_address1", this.deliadd);
      }
      if(this.certificateForm.deli_address2) {
        data.append("deli_address2", this.certificateForm.deli_address2);
      }
      if(this.certificateForm.deli_tel) {
        data.append("deli_tel", this.certificateForm.deli_tel);
      }
      if(this.certificateForm.national_cert1) {
        data.append("national_cert1", this.certificateForm.national_cert1);
      }
      if(this.certificateForm.national_cert2) {
        data.append("national_cert2", this.certificateForm.national_cert2);
      }
      if(this.certificateForm.description) {
        data.append("description", this.certificateForm.description);
      }
      return data;
    },
  },
  async mounted() {
    const navigationBar = this.$parent.$parent.$parent;
    navigationBar.setFooter(['申請一覧', '申請詳細'], '/user/certificate', false);
  },
};
</script>
<style lang="scss" scoped>
.dropZone {
  position: relative;
}
.dropZone:hover {
  background-color: #e2f7fa !important;
}
.dropZone-over {
  background-color: #e2f7fa !important;
  opacity: 0.8;
}

.label-top {
  margin-top: -28px !important;
}
.tag1 {
  background-color: #efba0a;
}
.tag2 {
  background-color: $green;
}
.tag3 {
  background-color: #e85741;
}
.tag4 {
  background-color: #3fb2bc;
  width: 100px;
}
.nationalcertradio {
  width: 150px;
}
.status {
  font-size: 12px;
  display: inline-block;
  color: #fff;
  border-radius: 100px;
  text-align: center;
  padding: 9px 8px;
  height: 37px;
  width: 134px;
}
.header-line-driver {
  color: #1947a3;
  border-color: unset !important;
  border: 2px solid;
}
.line-driver {
  color: #1947a3;
  border-color: unset !important;
}
.info-line-driver {
  color: #1947a3;
  border-color: unset !important;
}
.v-card-bg-color {
  background-color: rgba(151, 206, 248, 0.44) !important;
  border: none !important;
  border-radius: 7px;
}
.custom-label {
  color: #606060 !important;
  font-weight: bold;
}
.custom-label-data {
  color: #606060 !important;
  font-size: 16px;
}
.pickup-title1 {
  margin-top: 30px;
}
.pickup-title2 {
  margin-left: 65px !important;
  margin-top: 5px;
}
.after-pickup-title1 {
  margin-top: 30px;
  text-align: center;
}
.after-pickup-title2 {
  text-align: center;
  margin-top: 5px;
}
.pickup-button {
  width: 150px;
}
.text-sub-title {
  font-size: $size-normal;
  color: $color-title;
  margin-top: 5px;
  padding-left: 7px;
}
.uploaded-data-title {
  font-size: 16px;
  color: #211917;
}
.btn-text {
  font-size: $size-btn-font;
  font-weight: bold;
  color: $white;
}
.btn-margin {
  margin-right: 20px !important;
}
.pickup2-mobile {
  margin-top: 10px !important;
  text-align: center;
}
.btn-pickup-margin {
  margin-left: 5px;
  background-color: #40b9b9 !important;
  color: #ffffff !important;
}
.btn-area {
  text-align: left;
}
// .punks-area {
//   width: 100%;
//   align-items: center;
//   background: white;
// }
// .punks-textpointer {
//   color: $user-punk-color;
//   cursor: pointer;
//   font-size: 13px;
// }
// .punks-text {
//   color: $user-punk-color;
//   font-size: 13px;
// }
.arrow-icon {
  height: 11px;
}
.sizepos {
  text-align: right;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.delete-icon {
  padding-top: 0;
}
.delete-icon:hover::before {
  opacity: 0 !important;
}
.imagePreviewWrapper {
  width: 132px;
  height: 132px;
  display: block;
  cursor: pointer;
  background-size: contain, cover;
  background-position: center center;
}
.link-color {
  color: #043099;
}
.scrollstyle {
  height: 270px;
  overflow-y: auto;
}
.scrollstyle::-webkit-scrollbar {
  width: 5px !important;
}
.scrollstyle::-webkit-scrollbar-thumb {
  background: #043099 !important;
  border-radius: 10px;
  box-shadow: unset !important;
}
.scrollstyle::-webkit-scrollbar-track {
  background: #e2f7fa !important;
  border-radius: 5px;
}
.diabtn {
  color: $user-primary;
  margin-top: 20px;
  text-align: center;
}
.data-link {
  color: #211917;
}
.file-name {
  color: $skyblue;
  cursor: pointer;
}
.trash-icon {
  width: 20px;
  height: 22px;
}
.truncate {
  max-width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 768px) {
  .btn-text {
    width: 130px;
  }
}
/* phone size */
@media screen and (max-width: 763px) {
  .container {
    margin-left: 0px !important;
  }
  .common-title {
    display: none;
  }
  .btn-margin {
    margin: 0 auto !important;
  }
  .display-checkbox {
    margin-left: 8px !important;
  }
  .vip-mobile {
    margin-left: 8px !important;
  }
  .image_up {
    flex-wrap: unset !important;
  }
  // .punks-area {
  //   margin-bottom: 4px !important;
  // }
}
/* ipad size */
@media (min-width: 768px) and (max-width: 1023px) {
  .btn-text {
    width: 160px !important;
  }
  .after-pickup-title1 {
    margin-top: 25px !important;
    margin-left: 11px !important;
    text-align: center !important;
  }
  .after-pickup-title2 {
    margin-left: -6px !important;
    margin-top: 5px !important;
    text-align: center !important;
  }
}
@media screen and (max-width: 763px) {
  .admin-user-info .container {
    width: 100% !important;
  }
  .btn-text {
    margin-bottom: 40px !important;
  }
  .upload-box {
    &.thumbnail-upload-box {
      padding-right: 0px;
    }
  }
}
@media screen and (max-width: $size-pc-min) {
  .after-pickup-title1 {
    margin-top: 20px;
    margin-left: 5px;
    text-align: center;
  }
  .after-pickup-title2 {
    text-align: center;
    margin-top: 5px;
  }
  .sizepos {
    text-align: right;
  }
  .custom-label-data {
    font-size: 14px;
  }
}
@media screen and (max-width: $size-mobile) {
  .sizepos {
    text-align: left;
  }
  .image_up {
    margin-top: 2px;
  }
  .nationalcertradio {
    width: 124px;
  }
  .custom-label-data {
    font-size: 14px;
  }
}
@media (min-width: 1024px) and (max-width: $size-pc-min) {
  .after-pickup-title1 {
    margin-top: 30px;
  }
  .after-pickup-title2 {
    text-align: center;
  }
}
</style>
<style lang="scss">
.v-textarea {
  .v-text-field__slot {
    padding: 0 4px 4px 0;
  }
}
.dia-icon {
  .svg-icon {
    width: 22px !important;
    height: 29px !important;
  }
}
.user-application-info {
  .input-login {
    .theme--light.v-icon {
      color: $admin-primary;
    }
  }
  .v-sheet.v-card:hover {
    background-color: #e2f7fa;
  }
}
.main-title {
  font-size: $size-title;
  color: $user-header-title;
  font-weight: bold;
  align-items: center;
}
.dialog-content {
  overflow-y: auto;
}
.v-list-item__subtitle {
  white-space: unset !important;
}
.vcard-upload {
  border: 3px dotted #1947a3 !important;
}
.popup-vcard {
  border: none !important;
  height: 410px;
}
.pastdata {
  width: max-content;
}
@media screen and (max-width: $size-mobile) {
  .user-application-info {
    overflow: hidden;
    .container {
      padding: 0 !important;
    }
  }
  .btn-area {
    text-align: center !important;
  }
  .pickup-title1 {
    margin-top: 0px !important;
    margin-left: 10px !important;
  }
  .pickup-title2 {
    margin-left: 65px !important;
    margin-top: 5px !important;
  }
  .img-upload-part {
    display: flex !important;
  }
  .after-pickup-title1 {
    margin-left: 0px !important;
    font-size: 11px !important;
    text-align: center !important;
    margin-top: 30px !important;
  }
  .after-pickup-title2 {
    margin-left: 0px !important;
    margin-top: 10px !important;
    font-size: 11px !important;
    text-align: center !important;
  }
  .btn-pickup-font {
    font-size: 14px !important;
  }
  .pickup1-mobile {
    margin-top: 30px !important;
    font-size: 11px !important;
  }
  .pickup2-mobile {
    font-size: 11px !important;
  }
}
@media (min-width: 320px) and (max-width: 375px) {
  .after-pickup-title1 {
    margin-top: 30px !important;
  }
  .pickup-button {
    width: 120px !important;
  }
  .pickup1-mobile {
    margin-top: 20px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }
  .btn-pickup-margin {
    margin-left: 0px;
  }
}
</style>
